"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _events = _interopRequireDefault(require("./events.js"));
/**
 * Generate an API method that will queue calls until the event is called or
 * instantly call the function when the event has already been called.
 *
 * @param {String} name Name of the event we want to subscribe to.
 * @returns {Function} The API method.
 * @public
 */
function eventToAPI(name) {
  let cache = null;

  //
  // Note that we're using on instead of once here so that any updates are
  // correctly refreshing our internal cache.
  //
  _events.default.on(name, function store(data) {
    cache = data;
  });

  /**
   * The actual API method that we expose to our users.
   *
   * @param {Function} fn Error first style completion callback.
   * @public
   */
  return function wrapper(fn) {
    if (cache) return fn(null, cache);
    _events.default.once(name, data => fn(null, data));
  };
}
var _default = eventToAPI;
exports.default = _default;